module.exports = __webpack_public_path__ + "img/pencil.afc89771.svg";